<template>
  <div>
    <Header :showProductTour="false" />
    <div id="label-comparison">
      <b-overlay :show="loading" rounded="sm">
        <b-form-select
          class="m-md-1 w-25 float-left"
          v-model="firstFile"
          :options="allFiles"
          @change="generateComparison()"
        ></b-form-select>
        <b-form-select
          class="m-md-1 w-25 float-right"
          v-model="secondFile"
          :options="allFiles"
          @change="generateComparison()"
        ></b-form-select>
        <div class="d2h-wrapper">
          <div ref="labelComparison" v-html="outputHtml"></div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import * as Diff2Html from 'diff2html';
const Diff = require('diff');
import { nivolumab1 } from '@/assets/dummyData/nivolumab1';
import { nivolumab2 } from '@/assets/dummyData/nivolumab2';
import { nivolumab3 } from '@/assets/dummyData/nivolumab3';
import { nivolumab4 } from '@/assets/dummyData/nivolumab4';
import { nivolumab5 } from '@/assets/dummyData/nivolumab5';
import { nivolumab6 } from '@/assets/dummyData/nivolumab6';
import { nivolumab7 } from '@/assets/dummyData/nivolumab7';

export default {
  name: 'LabelComparison',
  components: {
    Header,
  },
  data() {
    return {
      loading: true,
      diff: '',
      outputHtml: '',
      allFiles: [],
      firstFile: 'Nivolumab Label dated Sep 07, 2021',
      secondFile: 'Nivolumab Label dated Sep 29, 2021',
    };
  },
  async mounted() {
    this.allFiles = [
      'Nivolumab Label dated Sep 29, 2021',
      'Nivolumab Label dated Sep 07, 2021',
      'Nivolumab Label dated Aug 06_2021',
      'Nivolumab Label dated Jul 28_2021',
      'Nivolumab Label dated Jun 01, 2021',
      'Nivolumab Label dated Sep 30, 2019',
      'Nivolumab Label dated Sep 19, 2017',
    ];
    this.allFileTexts = {
      'Nivolumab Label dated Sep 29, 2021': `${nivolumab1}`,
      'Nivolumab Label dated Sep 07, 2021': `${nivolumab2}`,
      'Nivolumab Label dated Aug 06_2021': `${nivolumab3}`,
      'Nivolumab Label dated Jul 28_2021': `${nivolumab4}`,
      'Nivolumab Label dated Jun 01, 2021': `${nivolumab5}`,
      'Nivolumab Label dated Sep 30, 2019': `${nivolumab6}`,
      'Nivolumab Label dated Sep 19, 2017': `${nivolumab7}`,
    };
    this.generateComparison();
  },
  methods: {
    async createPatch() {
      return Diff.createTwoFilesPatch(
        this.firstFile,
        this.secondFile,
        this.allFileTexts[this.firstFile],
        this.allFileTexts[this.secondFile]
      );
    },
    async generateDiff2Html(diff) {
      return Diff2Html.html(diff, {
        inputFormat: 'diff',
        showFiles: true,
        matching: 'lines',
        highlight: true,
        outputFormat: 'side-by-side',
      });
    },
    async generateComparison() {
      this.loading = true;
      setTimeout(() => {
        this.diff = this.createPatch()
          .then((diff) => this.generateDiff2Html(diff))
          .then((diff2html) => {
            this.outputHtml = diff2html;
            this.loading = false;
          });
      }, 500);
    },
  },
};
</script>

<style>
#label-comparison {
  margin-top: 150px;
  padding: 10px;
  align-items: center;
  text-align: center;
  width: 100%;
}
/* .d2h-wrapper {
  width: 100% !important;
}
.d2h-code-line,
.d2h-code-line-ctn {
  white-space: pre-wrap !important;
}

.d2h-diff-tbody > tr > td {
  line-height: 1;
} */
</style>
